import { apiClient } from "lib/apiClient";
import {
  IResearchVersionRequest,
  IResearchWorkItem,
} from "features/Research/types";

export const claimResearchWorkItem = async (
  workItemId: string,
  request: IResearchVersionRequest
): Promise<IResearchWorkItem> => {
  const response = await apiClient.post(
    `/research/work-items/${workItemId}/claim`,
    request
  );
  return response.data;
};
